import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M6.5 16.75C5.811 16.75 5.25 17.311 5.25 18C5.25 18.689 5.811 19.25 6.5 19.25C7.189 19.25 7.75 18.689 7.75 18C7.75 17.311 7.189 16.75 6.5 16.75ZM6.25 18C6.25 17.862 6.362 17.75 6.5 17.75C6.638 17.75 6.75 17.862 6.75 18C6.75 18.275 6.25 18.275 6.25 18Z"
      fill="currentColor"
    />
    <path
      d="M20.971 15.357C20.968 15.345 20.968 15.334 20.964 15.323C20.93 15.234 20.87 15.163 20.795 15.107C20.787 15.101 20.785 15.09 20.777 15.084L16.403 12.168C16.238 12.058 16.047 12 15.849 12H8.151C7.953 12 7.761 12.058 7.596 12.168L3.222 15.084C3.213 15.09 3.212 15.101 3.204 15.107C3.129 15.163 3.069 15.234 3.035 15.323C3.031 15.334 3.032 15.346 3.028 15.357C3.015 15.403 3 15.449 3 15.5V20C3 20.552 3.449 21 4 21H20C20.552 21 21 20.552 21 20V15.5C21 15.449 20.985 15.403 20.971 15.357ZM8.151 13H15.848L18.848 15H5.151L8.151 13ZM20 20H4V16H20V20Z"
      fill="currentColor"
    />
    <path
      d="M11.646 10.853C11.692 10.899 11.748 10.936 11.809 10.962C11.87 10.988 11.935 11 12 11C12.065 11 12.13 10.987 12.191 10.962C12.253 10.937 12.308 10.9 12.354 10.853L15.353 7.854C15.548 7.659 15.548 7.342 15.353 7.147C15.158 6.952 14.841 6.952 14.646 7.147L12.5 9.293V3.5C12.5 3.224 12.276 3 12 3C11.724 3 11.5 3.224 11.5 3.5V9.293L9.35398 7.146C9.15898 6.951 8.84198 6.951 8.64698 7.146C8.45198 7.341 8.45198 7.658 8.64698 7.853L11.646 10.853V10.853Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Download');

export default Icon;
